import { ArrowUUpRightIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Redo = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <ArrowUUpRightIcon size={Sizes[size]} {...rest} />;
};

Redo.displayName = 'Redo';
